import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CancelWorkflowInput {
    orderId: string;
    workflowId: string;
}

const cancelWorkflow = async (data: CancelWorkflowInput, sessionId: string | null) => {
    return axios.put(
        `${API_URL}/workflow/cancel`,
        { workflowId: data.workflowId },
        {
            headers: {
                Authorization: sessionId,
            },
        },
    );
};

export const useCancelWorkflow = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CancelWorkflowInput) => cancelWorkflow(data, sessionContext?.sessionId ?? null),
        onSettled: (_data, _error, variables) => {
            queryClient.invalidateQueries({ queryKey: ['/order/workflow-status', variables.orderId] });
        },
    });
};
